import { KeyValueEntity } from '../Types/base';
import { get, post } from './common';

const layoutEndpoint = 'api/layout';

const KEY_BACKEND_PREFIX = 'HTML_SEG_';

function mapHtmlSegments(entities: KeyValueEntity[] | null): KeyValueEntity[] {
	if (!entities) return [];
	return entities.map((entity) => {
		return {
			Key: entity.Key.replace(KEY_BACKEND_PREFIX, ''),
			Value: entity.Value,
		};
	});
}

export async function getHtmlSegments(keyStartsWith: string) {
	const params = new URLSearchParams({ keyStartsWith: `${KEY_BACKEND_PREFIX}${keyStartsWith}` });
	const endpoint = `${layoutEndpoint}/GetHtmlSegments?${params}`;
	const result = await get<KeyValueEntity[]>(endpoint);
	return mapHtmlSegments(result);
}

export async function saveHtmlSegment(key: string, content: string) {
	const endpoint = `${layoutEndpoint}/SaveHtmlSegment`;
	const result = await post<boolean>(endpoint, { Key: `${KEY_BACKEND_PREFIX}${key}`, Value: content });
	return result;
}

export type CMSPageListItem = {
	Id: number;
	Name: string;
	CMSDescription?: string;
	UrlRewrite: string;
	ImageUrl?: string;
	IsActive: boolean;
};

export async function getCMSPagesByIds(ids: number[]): Promise<CMSPageListItem[]> {
	if (ids.length === 0) return [];

	const uniqueIds = [...new Set(ids)];
	const response = await get<CMSPageListItem[]>(`api/cmsuser/GetCMSPages?ids=${uniqueIds.join(',')}`);
	return response ?? [];
}
